<template>
  <v-row class="d-flex justify-center flex-column flex-sm-row">
    <v-col class="pa-3" cols="12" md="6">
      <img src="../assets/newsinbashi.png" class="ma-auto w-100 w-md-50" />
      <!-- <template #sources>
          <source srcset="../assets/newsinbashi.webp" />
        </template> -->
    </v-col>
    <v-col class="text-h6">
      <p>①メイン会場/受付「THE CAFE」</p>
      <p>②サブ会場「昭和ブックカフェ」</p>
      <p>③トークショー/サイン会「ニュー新橋コワーキング」</p>
    </v-col>
  </v-row>
  <v-sheet align="center">
    <v-btn
      @click="openPdf"
      target="_blank"
      variant="tonal"
      class="pa-2 my-4"
      color="green-darken-3"
      size="x-large"
      >メイン会場/サブ会場 出展配置マップ(PDF)</v-btn
    >
  </v-sheet>
</template>
<script>
  export default {
    methods: {
      openPdf() {
        // 新しいウィンドウまたはタブで PDF ファイルを開く
        window.open("http://d-mebius.com/fusigi_na_game/src/map.pdf", "_blank");
      },
    },
  };
</script>
